<template>
  <div class="olds">
    <Header titles="已领任务" />
      <List
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        offset="600"
      >
        <div class="eve-task">
          <router-link :to="{path:'/get',query: {task_id: item.task_id}}" class="eve-mytask" v-for="item in lists" :key="item.id" >
            <div class="task-header">
                <div class="task-header__left"><img class="taskti" src="@/assets/image/tasks.png" alt=""><span>{{item.title}}</span></div>
                <div class="task-header__right" v-if="item.task_tag !== 'PAB顾问'">￥{{item.award | strChange}}</div>
              </div>
              <div class="line-left">
                <div class="task-footer">
                  <div class="footer-time">
                    <span>{{item.plan_start_time ? item.plan_start_time.substr(0,10):''}}</span>
                    <span> ~ </span>
                    <span>{{item.plan_end_time ? item.plan_end_time.substr(0,10):''}}</span>
                  </div>
                </div>
                <div class="task-main">
                  <div class="task-main__left">
                    <div class="task-left__type">
                      {{item.task_mech}}
                    </div>
                    <template v-for="(tag, index) in item.task_tag" >
                      <div class="task-left__type" v-if="index < 3 && tag" :key="'tag'+ index">
                        {{tag}}
                      </div>
                    </template>
                    <div class="task-left__jin" v-if="item.urgent_level == '紧急'">
                      {{item.urgent_level}}
                    </div>
                  </div>
                  <div class="task-main__right" :style="background(item.status)">{{item.status}}</div>
                </div>
              </div>
          </router-link>
        </div>
      </List>
  </div>
</template>

<script>
import Header from '@/components/header.vue'
import { getOldTask } from '@/api/api/task'
import { List } from 'vant'
export default {
  data() {
    return {
      page: 0,
      lists: [],
      finished: false,
      total: 0,
      isloading: true
    }
  },
  components: {
    Header,
    List
  },
  created() {
    this.getTask()
  },
  methods: {
    background() {
      // if(val === '评审中') {
        return { 'background-color': '#ffebd4', color: '#ffa843' }
      // }
    },
    onLoad() {
      if(!this.isloading) return
      if(this.total < 10) {
        return
      }
      if((this.page *10) < this.total) {
        this.isloading = false
        this.getTask()
      }
    },
    getTask() {
      this.page++
      getOldTask(this.page).then(res => {
        
        res.data.data.list.forEach(ele => {
          ele.task_tag = ele.task_tag.split(',')
        })
        this.lists = [...this.lists,...res.data.data.list]
        if(res.data.data.list.length < 10) this.finished = true
        this.total = res.data.data.total
        setTimeout(() => {
          this.isloading = true
        },1000)
      })
    },
  },
}
</script>

<style lang="scss">
.olds {
  padding-top: 54px;
  .eve-task {
    min-height: 600px;
  }
  .eve-mytask {
    border-radius: 6px;
    display: block;
    height: 138px;
    margin-bottom: 16px;
    padding: 22px 25px 0 21px;
    .task-footer {
      display: flex;
      justify-content: space-between;
      height: 38px;
      margin-bottom: 4px;
      .task-footer-type {
        display: flex;
          .footer-nos {
            height: 38px;
            width: 38px;
            text-align: center;
            line-height: 38px;
            color: white;
            font-weight: 600;
            font-size: 16px;
            border-radius: 50%;
            background-color: #ccc;
          }
          .footer-derl {
            width: 72px;
            height: 25px;
            text-align: center;
            line-height: 25px;
            color: white;
            background: #BE0000;
            border-radius: 2px;
        }
      }
      .footer-time {
        margin-top: 8px;
        color: #828593;
      }
    }
    .task-header {
        display: flex;
        justify-content: space-between;
        height: 25px;
        align-items: center;
        margin-bottom: 6px;
        .task-header__left {
          display: flex;
          align-items: center;
          .taskti {
            margin-right: 6px;
            width: 24px;
            height: 24px;
          }
          font-size:15px;
          letter-spacing: 1px;
          font-weight: 600;
          color: #25245d;
        }
        .task-header__right {
          height:25px;
          font-size:12px;
          font-weight:600;
          color:#808694;
          line-height:25px;
        }
      }
  }
  .task-main {
      display: flex;
      justify-content: space-between;
      height: 36px;
      margin-bottom: 8px;
      align-items: center;
      .task-header__right {
        font-size: 16px;
        color: #ff6565;
      }
      .task-main__right {
        width: 76px;
        height: 26px;
        text-align: center;
        line-height: 26px;
        border-radius: 4px;
      }
      .task-main__left {
        display: flex;
        .task-left__type {
          padding: 0 4px;
          height: 20px;
          border-radius: 4px;
          text-align: center;
          line-height: 20px;
          background: #F3F3F3;
          font-size: 12px;
          color:#8988AB;
          margin-right: 8px;
        }
        .task-left__jin {
          padding: 0 6px;
          height: 20px;
          border-radius: 50%;
          background: #F91400;
          text-align: center;
          line-height: 20px;
          font-size: 12px;
          color:white;
        }
      }
    }
  .line-left {
    margin-left: 11px;
    border-left: 1px solid #e9e9ed;
    padding-left: 18px;
    height: 87px;
  }
}
</style>